<template lang="pug">
  app-combobox(:value="value" :items="items" :search-input.sync="search" @input="handleInput" item-text="name" item-value="name" label="Теги" hide-selected multiple small-chips deletable-chips menu-props="closeOnContentClick")
</template>

<script>
export default {
  name: 'app-tags-combobox',

  props: {
    value: [String, Object, Array],
    items: {
      type: Array,
      required: true
    }
  },

  methods: {
    handleInput (...params) {
      this.$emit('input', ...params)
    }
  },

  data () {
    return {
      search: ''
    }
  }
}
</script>